module.exports = __webpack_public_path__ + "img/24.4692895d.jpg";